import { render, staticRenderFns } from "./Send-Mail.vue?vue&type=template&id=78c1e37c&scoped=true&"
import script from "./Send-Mail.vue?vue&type=script&lang=js&"
export * from "./Send-Mail.vue?vue&type=script&lang=js&"
import style0 from "./Send-Mail.vue?vue&type=style&index=0&id=78c1e37c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c1e37c",
  null
  
)

export default component.exports